import EventsBlockPreview from "./EventsBlockPreview";

export default EventsBlockPreview;